export default __webpack_public_path__ + "static/media/icon-algohealth-n@2x.9cf73dfa.webp";